import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { api } from '../api'
import Pager from '../components/Pager'
import type { Paged } from '../types'
import { when } from '../util'

const LIMIT = 50

interface AuditRow {
  at: string
  action: string
  target: string | null
  payload: Record<string, unknown> | null
  ip: string | null
  actor: string | null
}

export default function Audit() {
  const [offset, setOffset] = useState(0)
  const { data, error, isLoading } = useQuery<Paged<AuditRow>>({
    queryKey: ['audit', offset],
    queryFn: () => api<Paged<AuditRow>>(
      `/admin/audit?limit=${LIMIT}&offset=${offset}`),
  })

  if (isLoading) return <p className="muted">Loading…</p>
  if (error) return <div className="err">{(error as Error).message}</div>
  const rows = data?.rows ?? []

  return (
    <>
      <h1>Audit</h1>
      <p className="sub">
        Operator actions. Append-only — enforced by a database trigger, not by
        convention.
      </p>
      <div className="panel">
        <header>Recent</header>
        {rows.length === 0 ? (
          <div className="empty">Nothing recorded yet.</div>
        ) : (
          <div className="scroll">
            <table>
              <thead>
                <tr><th>When</th><th>Who</th><th>Action</th><th>Target</th>
                    <th>Detail</th><th>IP</th></tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>
                    <td className="muted">{when(r.at)}</td>
                    <td>{r.actor ?? '—'}</td>
                    <td><span className="chip">{r.action}</span></td>
                    <td className="muted" style={{ fontSize: '.8rem' }}>{r.target}</td>
                    <td className="wrap muted">
                      {r.payload ? JSON.stringify(r.payload) : '—'}
                    </td>
                    <td className="muted">{r.ip ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Pager total={data?.total ?? 0} limit={LIMIT} offset={offset}
               onOffset={setOffset} noun="entry" />
      </div>
    </>
  )
}
